import React, { useState, useMemo, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Form } from 'antd';
import InputForm from '../../../../InputT';
import SearchModal from '../../../../SearchModal';
import SelectOption from '../../../../SelectOption';
import Params from '../../../../../Types/ParamsPicklist';
import { SwipeUp } from '@mui/icons-material';

// Paramètres de recherche
let searchParamsIjarah: Params = {
  CodeAgence: '',
  Table: 'ParamsIjara',
  Colonne1: 'CodeIjara',
  Colonne2: 'LibelleIjara',
  Colagence: '101',
  Choix: 22,
};
let searchPeriod: Params = {
  CodeAgence: '',
  Table: 'v_period_lib',
  Colonne1: 'CODLIB',
  Colonne2: 'LIBELL',
  Colagence: '101',
  Choix: 22,
};
let searchActivite: Params = {
  CodeAgence: '',
  Table: 'TABNAE',
  Colonne1: 'CODNAE',
  Colonne2: 'LIBELL',
  Colagence: '101',
  Choix: 22,
};
let searchIndice: Params = {
  CodeAgence: '',
  Table: 'CLIENT',
  Colonne1: 'NUMCLI',
  Colonne2: 'NOMCLI',
  Colagence: '101',
  Choix: 22,
};
let searchObjet: Params = {
  CodeAgence: 'MOTIFPRET',
  Table: 'LIB',
  Colonne1: 'CODLIB',
  Colonne2: 'LIBELL',
  Colagence: 'RUBRIQ',
  Choix: 22,
};
let searchActif: Params = {
  CodeAgence: '',
  Table: 'Actif',
  Colonne1: 'CodeActif',
  Colonne2: 'Designation',
  Colagence: '',
  Choix: 22,
};
let searchFournisseur: Params = {
  CodeAgence: '',
  Table: 'FOURNIS',
  Colonne1: 'CODFOUR',
  Colonne2: 'NOMFOUR',
  Colagence: '101',
  Choix: 22,
};

interface Tab1Props {
  form: any;
  consultTypeIjarah: Function;
}

function Tab1({ form, consultTypeIjarah }: Tab1Props) {
  // Surveillance des champs de la demande pour pré-remplir la proposition
  const coutAcquisitionDemande = Form.useWatch('CoutAcquisitionDemande', form) || 0;
  const margeLocativeDemande = Form.useWatch('MargeLocativeDemande', form) || 0;
  const valeurResiduelleDemande = Form.useWatch('ValeurResiduelleDemande', form) || 0;

  // Pré-remplir les champs de proposition avec les valeurs de la demande (sauf si déjà modifiés)
  useEffect(() => {
    if (coutAcquisitionDemande && !form.getFieldValue('CoutAcquisitionPropose')) {
      form.setFieldValue('CoutAcquisitionPropose', coutAcquisitionDemande);
    }
  }, [coutAcquisitionDemande, form]);

  useEffect(() => {
    if (margeLocativeDemande && !form.getFieldValue('MargeLocativePropose')) {
      form.setFieldValue('MargeLocativePropose', margeLocativeDemande);
    }
  }, [margeLocativeDemande, form]);

  useEffect(() => {
    if (valeurResiduelleDemande && !form.getFieldValue('ValeurResiduellePropose')) {
      form.setFieldValue('ValeurResiduellePropose', valeurResiduelleDemande);
    }
  }, [valeurResiduelleDemande, form]);

  const numcliValue = Form.useWatch('NUMCLI', form);
  const codeIjaraValue = Form.useWatch('CodeIjara', form);

  const searchNumCompte = useMemo<Params>(() => ({
    CodeAgence: numcliValue || '',
    Table: 'ViewAnyIjarahCptRembousement',
    Colonne1: 'NUMCPT',
    Colonne2: 'NOMCPT',
    Colagence: 'NUMCLI',
    colfiltre: 'CodeIjara',
    valfiltre: codeIjaraValue || '',
    Choix: 22,
  }), [numcliValue, codeIjaraValue]);

  const handleTypeIjarahSelect = () => {
    consultTypeIjarah();
  };

  const handleClientChange = () => {
    form.setFieldValue('CPTREMBOURSEMENT', '');
  };

  return (
    <div className='tabItem'>
      <Box width={'85%'} overflow={'auto'} padding={1}>
        {/* Bloc DEMANDE (lecture seule) */}
        <Box fontStyle='inherit' className='border' width={'100%'} mb={3}>
          <Typography variant='subtitle1' color='primary' sx={{ p: 1, fontWeight: 'bold' }}>
            📋 Données de la demande
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} className='border-left' style={{ padding: '8px' }}>
              <InputForm disabled notRequired width={5} label='Numéro Demande' name='NumeroDemande' type='text' />
              <SearchModal
                disabled
                ExecuteafterSelect2={handleClientChange}
                width={5}
                form={form}
                Titre='Recherche Client'
                label='Client'
                name='NUMCLI'
                Parametre={searchIndice}
              />
              <SelectOption
                disabled
                width={5}
                label='Compte remboursement'
                name='CPTREMBOURSEMENT'
                Parametre={searchNumCompte}
              />
              <SearchModal disabled width={5} form={form} Titre='Objet du financement' label='Objet' name='CODOBJECT' Parametre={searchObjet} />
              <SearchModal disabled width={5} form={form} Titre='Motif' label='Motif' name='MOTIFDEM' Parametre={searchObjet} />
              <SearchModal disabled width={5} form={form} Titre="Activité du client" label='Activité' name='CODACTIVE' Parametre={searchActivite} />
              <InputForm disabled width={5} label="Durée contrat (mois)" name='DureeContrat' type='number' />
              <InputForm disabled width={5} label="Durée différée (mois)" name='DureeDifferee' type='number' />
              <InputForm disabled width={5} label="Durée amortissement (mois)" name='DureeAmortBien' type='number' />
              <InputForm disabled width={5} label="Montant Promesse" name='MontantPromesse' type='number' />
              <InputForm disabled width={5} label="Montant Charge" name='MontantCharge' type='number' />
              <InputForm disabled width={5} label="Nombre échéances" name='NombreEch' type='number' />
              <InputForm disabled width={5} label="Nombre échéances amortissement" name='NombreEchAmort' type='number' />
              <InputForm disabled width={5} label="Date 1ère échéance" name='DatePremEch' type='date' />
            </Grid>
            <Grid item xs={12} md={6} className='border-left' style={{ padding: '8px' }}>
              <SearchModal
                disabled
                handleFunction={() => {}}
                ExecuteafterSelect1={handleTypeIjarahSelect}
                width={5}
                form={form}
                Titre='Type de Ijarah'
                label='Code Ijarah'
                name='CodeIjara'
                Parametre={searchParamsIjarah}
              />
              <SearchModal disabled width={5} form={form} Titre="Actif" label='Actif' name='CodeActif' Parametre={searchActif} />
              <SearchModal disabled width={5} form={form} Titre="Fournisseur" label='Fournisseur' name='CPTREGLEMENT' Parametre={searchFournisseur} notRequired/>
              <InputForm disabled width={5} money label="Coût d'acquisition (demande)" name='CoutAcquisitionDemande' type='number' />
              <InputForm disabled width={5} money label="Marge locative (demande)" name='MargeLocativeDemande' type='number' />
              <InputForm disabled width={5} money label="Valeur résiduelle (demande)" name='ValeurResiduelleDemande' type='number' />
              <InputForm disabled width={5} label="Périodicité" name='Periodicite' type='text' />
              <InputForm disabled width={5} label="Périodicité amortissement" name='PeriodiciteAmort' type='text' />
              <InputForm disabled width={5} label='Frais de service' name='MontantFrais' type='number' />
              <InputForm disabled width={10} label='Commentaire demande' name='CommentaireDemande' type='TextArea' row={2} />
            </Grid>
          </Grid>
        </Box>

        {/* Bloc PROPOSITION (champs modifiables) */}
        <Box fontStyle='inherit' className='border' width={'100%'}>
          <Typography variant='subtitle1' color='success' sx={{ p: 1, fontWeight: 'bold' }}>
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} className='border-left' style={{ padding: '8px' }}>
              <InputForm
              disabled
                width={5}
                money
                label="Coût d'acquisition proposé"
                name='CoutAcquisitionPropose'
                type='number'
              />
              <InputForm
              disabled
                width={5}
                money
                label="Marge locative proposée"
                name='MargeLocativePropose'
                type='number'
              />
              <InputForm
              disabled
                width={5}
                money
                label="Valeur résiduelle proposée"
                name='ValeurResiduellePropose'
                type='number'
              />
            </Grid>
            <Grid item xs={12} md={6} className='border-left' style={{ padding: '8px' }}>
              <InputForm
                disabled
                width={10}
                label='Commentaire de la proposition'
                name='CommentairePropose'
                type='TextArea'
                row={4}
                notRequired
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}

export default Tab1;